import Vue, { computed, reactive, getCurrentInstance } from 'vue';
import Router from 'vue-router';

import Home from '@/pages/Home.vue';

import UsuariosRoutes from './usuarios.js';

import ClientesRoutes from './clientes.js';
import VeiculosRoutes from './veiculos.js';
import FuncionariosRoutes from './funcionarios.js';
import FornecedoresRoutes from './fornecedores.js';
import PecasRoutes from './pecas.js';
import ServicosRoutes from './servicos.js';
import OrdemServicoRoutes from './ordemservico.js';
import TiposClientesRoutes from './tiposclientes.js';
import TiposFuncionariosRoutes from './tiposfuncionarios.js';
import TiposOSRoutes from './tiposos.js';
import PrazosRoutes from './prazos.js';
import FormasPagamentoRoutes from './formaspagamento.js';
import BancosRoutes from './bancos.js';
import GruposRoutes from './grupos.js';
import EstoqueRoutes from './estoque.js';
import ComissoesRoutes from './comissoes.js';
import AgendaRoutes from './agenda.js';
import FolhaPagamentoRoutes from './folhapagamento.js';
import NotasFicaisRoutes from './notasfiscais.js';

import PublicoRoutes from './publico.js';
import SistemaRoutes from './sistema.js';

import { guards } from './guards.js';

Vue.use(Router);

const router = new Router({
  mode: 'hash',

  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },

  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },

    {
      path: '*',
      meta: { public: true },
      redirect: { path: '/404' },
    },

    ...UsuariosRoutes,

    ...ClientesRoutes,
    ...VeiculosRoutes,
    ...FuncionariosRoutes,
    ...FornecedoresRoutes,
    ...PecasRoutes,
    ...ServicosRoutes,
    ...OrdemServicoRoutes,
    ...TiposClientesRoutes,
    ...TiposFuncionariosRoutes,
    ...TiposOSRoutes,
    ...PrazosRoutes,
    ...FormasPagamentoRoutes,
    ...BancosRoutes,
    ...GruposRoutes,
    ...EstoqueRoutes,
    ...ComissoesRoutes,
    ...AgendaRoutes,
    ...FolhaPagamentoRoutes,
    ...NotasFicaisRoutes,

    ...PublicoRoutes,
    ...SistemaRoutes,
  ],
});

router.beforeEach(guards);

export default router;


// Adaptação para usar o Vue-router no setup vue 2.7
// import { computed, reactive, getCurrentInstance } from 'vue'

export function useRouter() {
  return getCurrentInstance().proxy.$router
}

export function useRoute() {
  // return getCurrentInstance().proxy.$route;
  const currentRoute = computed(() => getCurrentInstance().proxy.$route)

  const protoRoute = Object.keys(currentRoute.value).reduce((acc, key) => {
      acc[key] = computed(() => currentRoute.value[key])
      return acc
  },{})

  return reactive(protoRoute)
}
